import { defineMessages } from 'react-intl';

export default defineMessages({
    primaryNamedInsured:{
        id:'gateway.views.account-contacts-list.Primary Named Insured',
        defaultMessage:'Primary Named Insured'
    } 
});
